import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, ActivationStart, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { UserData } from '@commoncore/constants/UserData';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import * as Bowser from "bowser";
import { ConnectionService } from 'ng-connection-service';
import { GlobalClassInstance } from 'projects/common-repo/src/app/core/constants/GlobalClass';
import { UserloginController } from 'projects/common-repo/src/app/core/controller/UserLoginController';
import { SessionStorageProps } from 'projects/common-repo/src/app/core/enums/sessionStorageProps';
import { GlobalService } from 'projects/common-repo/src/app/core/services/global.service';
import { ENV_CONSTANTS, environment } from 'properties/environment';
import { ENV_CONFIG } from 'properties/environment-config';
import { interval } from 'rxjs';
import { AppEvents, EventsList } from '../../../common-repo/src/app/core/utils/app-events';
import { DEFAULT_USER_DETAILS, USER_DETAILS } from './core/constants/Constants';

import { SettingsService } from '@commoncore/services/settings.service';
import { IndexedDBModule } from './core/database/IndexedDBManager';
import { ReferEarnService } from './core/services/refer-earn.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'JioCloudWeb';
  userloginController:any;//= new UserloginController()
  isOnline:boolean = true;   

  public http: any;
  public router: Router;
  public connectionService:ConnectionService;
  public universalService:any;
  public listService:any;
  loggerService: any
  localStorageSvc: any;
  pageReloaded: boolean;
  browserRefresh: boolean;
  currentRouteData;
  cleverTapEventsService: any;
  timer:any;
  windowTime:any;
  lastRefreshTime:any
  appSupported:boolean = true;
  loginImplRef: any;
  db: IndexedDBModule;
  sessionStorageService:any;
  redirectionService:any;
  cardsImplementation: any;
  disablePassphraseInCurrentModule:boolean = false;
  lazyInjectorService: any;
  searchService: any;
  browserBackClick:boolean = false;
  routesToIgnoreRedirectedRoute = ['document/editor',"/search","/jc-photo/editor"]
  deferredPrompt: any;
  showInstallButton: boolean;

  constructor(public globalService:GlobalService,
    private referEarnService: ReferEarnService, 
    private activatedRoute: ActivatedRoute,private renderer2: Renderer2,
    private settingsService : SettingsService) {
    this.setComponentProperties();
    this.universalService.activeRepo = "main";
    this.populateUserDataToLocalConstant();
    this.settingsService.fetchSettings();
    this.resetValues();
    this.setUniversalServiceInstance();
    this.registeringevents()
    this.subscribtionToConnectionService()
    this.subscriptionToRouteChanges();
    this.universalService.checkIfWebpIsSupported((supported)=>{
      this.universalService.isWebpSupported = supported;
    });
    this.universalService.checkIfGIFIsSupported((supported)=>{
      this.universalService.isGIFSupported = supported;
      console.log("isGIFSupported",supported)
    })
    
    let skipCheckingLoginStatus = ENV_CONFIG["routesToSkipCheckingLoginStatus"].some(obj=> {
      return window.location.href.includes(obj);
    })
    if(!skipCheckingLoginStatus){
      this.checkUserStatus();
    }else{
      this.lazyInjectResources();
    }
    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      let checkLogin = localStorage.jio;
      if(checkLogin == undefined && window.location.href.includes('?login') && (queryParams["params"]["login"] == undefined || queryParams["params"]["login"] == '')){
          this.router.navigate(["/signin"]);
      } else if(checkLogin && window.location.href.includes('?login') && (queryParams["params"]["login"] == undefined || queryParams["params"]["login"] == '')){
        this.takeoutRouting()
      }
     
    });
    let userData = this.localStorageSvc.getUserData(true);
    if(userData){
      if(userData["isTwoFAEnabled"] && !userData["2FAValidated"]){
        this.router.navigate(['/']);
      }else{
        if(((window.location.href == environment.baseUrl + '/') || window.location.href == environment.baseUrl || window.location.href.indexOf('about')> -1)  && this.router.url == ('/')){
          this.router.navigate(['/home'])
        }
      }
    }
  }
  @HostListener('drop', ['$event']) dropEvent(event){
    if (event.preventDefault) event.preventDefault();
  }

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {  
    if (event.preventDefault) event.preventDefault();
  };

  @HostListener('dragleave', ['$event']) dragLeaveEvent(event) {
    if (event.preventDefault) event.preventDefault();
  };

  private registeringevents(){
    let classRef = this;
    AppEvents.on(EventsList.CONNECTIONRESTORED_EVENT, ()=> {
      this.universalService.decideMemoryTimer();
      AppEvents.emit(EventsList.INTERNET_ON);
      AppEvents.internetEvents.next({internet_restored: true});
      if(USER_DETAILS["USER_DETAILS"]["isStaySignIn"]){//if(classRef.localStorageSvc.isStaySigned()){
        this.refreshData(true,true,true)}
      }
    )
    AppEvents.on(EventsList.CONNECTIONDOWN_EVENT, ()=> {
      AppEvents.emit(EventsList.INTERNET_OFF);
      this.universalService.pauseMemoryTimer();
      AppEvents.emit(EventsList.VIDEO_PLAYER_PAUSE);//pause video
      }
    )
  }

	private setUniversalServiceInstance(){
    // AppEvents.universalServiceRef = this.universalService;
    this.listService = this.globalService.getListServiceRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
    
  }

  resetValues(){
    this.sessionStorageService.removeSessionProperty(SessionStorageProps.BUY_STORAGE);
    this.removeLocalStorageUrlsForRedirections();
  }

  removeLocalStorageUrlsForRedirections(){
    var currentUrl = window.location.href;
    if(currentUrl == environment.baseUrl || currentUrl == environment.baseUrl + "/"){
      localStorage.removeItem(LocalStorageProps.REDIRECTION_URL);
      localStorage.removeItem(LocalStorageProps.INVITE_URL);
      sessionStorage.removeItem(SessionStorageProps.SHARE_KEY_WITH_EXPIRY);
      sessionStorage.removeItem(SessionStorageProps.SINGLE_SHARED_OBJECT_WITH_EXPIRY);
    }
  }


    subscriptionToRouteChanges(){
    this.router.events
      .subscribe(
        (event) => {
          if(event instanceof ActivationStart){
            this.currentRouteData = event.snapshot.data;
          }
          if(event instanceof NavigationStart){
            this.showFeaturesForEntUsers();
            var currentUrl = window.location.href;
            var currentRoute = event.url;
            this.universalService.showAutoSuggestion = false;
            let skipSavingRouteInLocalStorage = this.routesToIgnoreRedirectedRoute.some(obj=> {
              return window.location.href.includes(obj);
            })
            if(currentRoute != "/" && !skipSavingRouteInLocalStorage){
              sessionStorage.setItem('redirectedRoute',currentRoute) 
            }
            else if (currentUrl.includes('sign-up')){
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              let eventId = urlParams.get('event_id')
              if(eventId!=undefined && eventId!=null )
                this.universalService.eventId = eventId
              this.router.navigate(['/sign-up']);
            }else if (currentUrl.includes('waves')){
              const queryString = window.location.search;
              const urlParams = new URLSearchParams(queryString);
              this.universalService.eventId = urlParams.get('event_id')
              this.router.navigate(['/events/waves']);
            }
            
            else 
            if(currentUrl.includes('/invite?ic')){
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,window.location.href);
              // localStorage.setItem("requestedUrl",window.location.href);
            }else if(event.url.includes('/i/')){
              var url_string = event.url; //window.locatixon.href
              var url = new URL(url_string);
              var inviteKey = url.searchParams.get("c");
              localStorage.setItem("inviteKey", inviteKey[1])
              // localStorage.setItem("requestedUrl","invite");
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,"invite");
            }else if (event.url.includes('v=extend')){
              localStorage.clear();
              // localStorage.setItem("requestedUrl","promo");
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,"promo");
              this.router.navigate(['/']);
            }else if (currentUrl.includes('familyshare/userprofile')){
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,environment.baseUrl + '/userprofile');
            }else if (currentUrl.includes('experience')){
              this.cleverTapEventsService.experienceNowModalLocation = 'Email';
              // localStorage.setItem("requestedUrl",'/people');
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,'/people')
            }else if (currentUrl.includes('buystorage?v=email')){//url will be jicloud.com/buystorage?v=email when user is initiating purchase flow through email
              this.sessionStorageService.setObjectWithExpiry(SessionStorageProps.BUY_STORAGE, "true");
            }else if(currentUrl.includes('cloudbridge?v=backupemail') || currentUrl.includes('cloudbridge?v=webview')){
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,"/cloudbridge");
            }else if(event.url.includes('referandearn')){
              // localStorage.setItem("requestedUrl","referandearn")
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,"referandearn");
              this.referEarnService.isReferAndEarnLogin = true;
            } else if( event.url.includes("referral")){
              if (localStorage.jio) {
                localStorage.setItem("showReferral", "false");
                localStorage.setItem("showReferralDone", "true");
              } else {
                localStorage.setItem("showReferral", "true");
              }
                localStorage.setItem("showReferral", "false");
            } else if(event.url.includes("/userprofile")){
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,environment.baseUrl + '/userprofile');
            }else if(event.url.includes("/history")){
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL, "/dataexport/history");
            } else if (currentUrl.includes('/dataexport') && !currentUrl.includes("/history")){
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL, '/dataexport');
            }else if(event.url.includes('?jp=') && !localStorage.jio){
              var url_string = window.location.href;
              var url = new URL(url_string);
              var folderKey = url.searchParams.get("jp");
              console.log("route,",this.activatedRoute)
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL, JSON.stringify({route:"jpai",folderKey:folderKey}));
            }
            
            if(this.browserBackClick){  
              this.browserBackClick = false;
              let url = window.location.href;
              AppEvents.optionSelected.next({"closeAll":true});
              AppEvents.globalObservable.next({"closeAll":true});
              AppEvents.teamFolderSubscription.next({"closeAll":true});
              setTimeout(() => {
                  $('#custome_backdrop').remove();
              }, 10);
              if(url.includes(USER_DETAILS["USER_DETAILS"]["rootFolderKey"]) || url.endsWith('/allfiles') ){
                var registeredEvents = AppEvents.getRegisteredEvents();
                if(registeredEvents.includes(EventsList.MYFILES_TABBED_VIEW)){
                    AppEvents.emit(EventsList.MYFILES_TABBED_VIEW)
                }
              }                
              
            }
            
          }
          if (event instanceof NavigationEnd) {
            var checkLogin =localStorage.jio;
            var requestedUrl = this.redirectionService.getRequestedUrlFromLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL)
            if(checkLogin && requestedUrl == 'invite' && event.url.includes('/i')){
              this.inviteRouting();
            }
            else if(checkLogin && requestedUrl == 'promo'){ // we will always logout user when coming from promotions email
              this.promoRouting()
            }
            else if(event.url.includes('referandearn')){
              // localStorage.setItem("requestedUrl","referandearn")
              this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL,"referandearn");
              this.referEarnService.isReferAndEarnLogin = true;
            } else{
              if(checkLogin == undefined && this.router.url == ('/')){
                this.universalService.hideLeftMenu = true;
                this.universalService.userLoggedIn = false
                this.universalService.userLandingLoggedIn = false;
              }
              else if(checkLogin == undefined && this.router.url == ('/enterprise')){
                this.universalService.hideLeftMenu = true;
                this.universalService.userLoggedIn = false
                this.universalService.userLandingLoggedIn = false;
              } else if(checkLogin && this.currentRouteData["jchome"]){
                this.universalService.userLoggedIn = true
                this.universalService.hideLeftMenu = true;
                this.universalService.userLandingLoggedIn = true;
              }else if(event.url == "/" && event.url === event.urlAfterRedirects){
                this.router.navigate(['home'])
              }else if(event.url === event.urlAfterRedirects){
                this.universalService.showLoader = false;
                this.universalService.userLandingLoggedIn = false;
                this.universalService.hideLeftMenu = false;
              }
              else{
                this.universalService.userLandingLoggedIn = false;
                this.universalService.hideLeftMenu = false;
              }
            }
            let data = this.currentRouteData;
            let layoutType = "";
            this.universalService.iCloudBackup = false;
            this.universalService.allowPhotoEditInViewBasedOnAccessRights = true;
            this.universalService.showSearchBar = data["showSearch"] ? data["showSearch"]: false;
            this.universalService.showContactSearch = data["showContactSearch"] ? data["showContactSearch"]: false;
            this.universalService.containsOnlyPhotos = data["containsOnlyImages"] ? data["containsOnlyImages"]: false;
            this.universalService.allowUpload = data["allowUpload"] ? data["allowUpload"] : false;
            this.universalService.allowMoveDrag = data["allowMove"] ? data["allowMove"] : false;
            this.universalService.MSOfficeSupportedInModule = data["msdoceditallowed"] ? data["msdoceditallowed"] : false;
            this.universalService.showWhatsSearchable = data["what-is-searchable"] ? data["what-is-searchable"] : false;
            this.universalService.manageVersionsSupportedInModule = data["manageversionsallowed"] ? data["manageversionsallowed"] : false;
            this.universalService.photoEditSupportedInModule = data["photoEditSupported"] ? data["photoEditSupported"] : false;
            this.universalService.isShortcutKeyAllowedForOperation = data["shortcutKeyAllowed"] ? data["shortcutKeyAllowed"] : false;
            this.disablePassphraseInCurrentModule = data["disable2FA"] ? data["disable2FA"] : false;
            this.universalService.showBreadCrumbsInsideTabContent = data["breadcrumbInsideTabContent"] ? data["breadcrumbInsideTabContent"] : false;
            this.universalService.viewContainsFolders = data["includesfolders"] ? data["includesfolders"] : false;
            this.universalService.emptyTabViewRequiresMenu = data.emptyTabViewRequiresMenu ? data.emptyTabViewRequiresMenu : false;
            this.universalService.viewIsTabOriented = data["isTabOriented"] ? data["isTabOriented"] : false;
            this.universalService.searchType = data["searchType"] ? data["searchType"] : 'global';
            this.universalService.hideTopMenu = data["hideTopMenu"] ? data["hideTopMenu"] : false;
            ENV_CONFIG["constants"]["PAGE_LIMIT"] = data["page-limit"] ? data["page-limit"] : 100;
            if(this.universalService.isMobileDevice){
              layoutType = data['mlayout'] ? data["mlayout"] : 'non-virtual';
              this.universalService.virtualGridEnabled = layoutType == 'non-virtual' ? false : true;
            }else{
              layoutType = data['dlayout'] ? data["dlayout"] : 'non-virtual';
              this.universalService.virtualGridEnabled = layoutType == 'virtual' ? true  : false;
            }
            if(this.universalService.searchType == 'teamfolder'){
              if(!this.universalService.currentTeamFolder){
                this.searchService.updatePlaceholder.next({"text":TOAST.TEAM_FOLDER_SEARCH_PLACE_HOLDER});
              }
            }else{
              this.searchService.updatePlaceholder.next({"text":TOAST.DEFAULT_SEARCH_PLACE_HOLDER});
            }
            // if(this.searchService.aiSearchToggleEnabled){
            //   this.searchService.updatePlaceholder.next({"text":TOAST["AI_SEARCH_PLACEHOLDER"]});
            // }
          }
    });
  }

  
  
   async ngOnInit(){ 
   
    // if(window.location.href.includes("/waves/sign-up")){
    //   this.universalService.isWaveEvent = true
    //   return;
    // }
    let checkLogin =localStorage.jio;
    this.showDownTimeBanner();
    if(checkLogin){
      this.lazyInjectResources(); 
    }
    this.universalService.enableTeamFolders = ENV_CONSTANTS["constants"]["enableTeamFolders"];
    this.universalService.isPingEnabled=false
    if(this.localStorageSvc.getRecoverData(false) == "true")
    return;
    this.sessionStorageService.removeSessionProperty(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME);
    this.universalService.checkDeviceType();
    await this.universalService.fetchJSONContent();
    this.listService.listViewSortOrder = (localStorage.listViewSortOrder == null)?"&sort=%2DfileCreatedDate":localStorage.listViewSortOrder;
    this.universalService.sharePublicSortByDate = "%2DfileCreatedDate";
    this.universalService.sharePublicSortByUploadDate = "";
    if(localStorage.sharePublicSort == null || localStorage.sharePublicSort == undefined) {
      this.universalService.sharePublicSort = this.universalService.sharePublicSortByDate;
    } else {
      this.universalService.sharePublicSort = localStorage.sharePublicSort;
    }
    let sortTypeName = this.universalService.togglePublicSort(this.universalService.sharePublicSort);
    if(sortTypeName!=""){
        this.sessionStorageService.setSharePublicSortPropName(sortTypeName);
    }
    let userData = this.localStorageSvc.getUserData(true) 
    this.universalService.userLoggedIn =  userData? true : false;
    this.universalService.firstName = userData ? userData["firstName"] : "" ;
    this.universalService.lastName = userData ? userData["lastName"] : "";
    this.universalService.emailId = userData ? userData["emailId"] : "";
    this.userloginController.setEnvObjects(this.globalService);
    let url=window.location.href;
    // this.checkIfAppIsSupportedOnCurrentBrowser(); 
    this.universalService.initThemeLanguage(this.universalService.translate);
    this.universalService.setUpdateProfileIconPath();
    if(this.sessionStorageService.getShowToastAlbumEntUser()){
      let msg = TOAST["ENT_USER_ALBUM_NOT_ALLOWED"];
      this.universalService.showToast(msg, "error");
      this.sessionStorageService.removeSessionProperty(SessionStorageProps.SHOW_TOAST_ALBUM_ENT_USER)
    }

    this.checkIfCloudPCUser();  
    this.universalService.browserDetails = Bowser.parse(window.navigator.userAgent);
    if(!window.location.href.includes('webview') && !window.location.href.includes('clbkinweb') && !this.universalService.iframeLogin) {
      this.getBrowserDetails();
    } else {
      this.universalService.isSupprtedBrowser = true;
    }
    this.redirectToUnsupportedRoute();
    this.clearStore();
  }

  showDownTimeBanner(){
    let checkLogin =localStorage.jio;
    if(!checkLogin){
      if(ENV_CONSTANTS["constants"]["enableDowntimeBanner"]){
        this.universalService.showDownTimeBanner = true;
      }
    }
  }

  checkIfCloudPCUser(){
    let userData = this.localStorageSvc.getUserData(true);
		if(userData && userData["iframeLogin"] && userData["authProviderId"] == ENV_CONFIG["commonUrls"]["jiocloudpcAuthProviderId"] && !this.universalService.isMobileDevice){
			this.universalService.iframeLogin = true;
		}
	}

  redirectToUnsupportedRoute() {
    if(this.universalService.isSupprtedBrowser == false) {
     
    } else {
      this.universalService.hideLeftMenu = false;
      return
    }
  }

  getBrowserDetails(){
    if(!this.universalService.isBrowserSupported()){
      this.universalService.isSupprtedBrowser = false;
    }
  }

  setComponentProperties(){
    this.router = this.globalService.getRouterRef();
    this.http = this.globalService.getHttpClientRef();
    this.connectionService = this.globalService.getConnectionSvcRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.globalService.loggerService.log("using globalsrvice flags");
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.userloginController= UserloginController.getInstance(this.globalService);  
    this.db = IndexedDBModule.getInstance(this.globalService);
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    this.redirectionService = this.globalService.getRedirectionServiceRef();
    this.loginImplRef = this.userloginController.userLoginImplementation;
    this.userloginController.setEnvObjects(this.globalService);
    this.lazyInjectorService = this.globalService.getLazyInjectorServiceRef();
    this.searchService = this.globalService.getSearchServiceRef();
  }

  @HostListener('document:visibilitychange', ['$event'])
  async onVisibilityChange(ev: Event) {   
    var userData = this.localStorageSvc.getUserData(true);
    if(userData){
      if(document.visibilityState == 'visible'){
        await AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,"initiator":"visibilty change"});
      }
    }
    this.check2FAstatus("N");
    if ( this.documentHiddenStatus() && USER_DETAILS["USER_DETAILS"]["isStaySignIn"]){
      this.userloginController.setEnvObjects(this.globalService);
      this.refreshData(true,true,false);
    }
  };
  
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.browserBackClick = true;
  }
  
   documentHiddenStatus(){

     if(document.hidden)
       this.universalService.isPingEnabled=false

    return !(document.hidden)
   }   

   async refreshData(enablePingInterval,tabchange,pageRefresh){
      if(!this.universalService.refreshTokenInprocess){
        if (USER_DETAILS["USER_DETAILS"]["isStaySignIn"]){
          this.universalService.refreshTokenInprocess = true;
          await this.userloginController.refreshData(enablePingInterval,tabchange,pageRefresh);
        }
      }
   }

  subscribtionToConnectionService() {
    this.connectionService.monitor().subscribe(isConnected => {
      this.universalService.connectionStatus = isConnected["hasNetworkConnection"];
      if (isConnected["hasNetworkConnection"] && !this.isOnline) {
        this.isOnline = true;
        AppEvents.emit(EventsList.CONNECTIONRESTORED_EVENT)
      }
      else if (isConnected["hasNetworkConnection"] && this.isOnline) {
        this.isOnline = false;
        AppEvents.emit(EventsList.CONNECTIONDOWN_EVENT);
      } else if (isConnected["hasNetworkConnection"] == false && !this.isOnline) {
        this.isOnline = false;
        AppEvents.emit(EventsList.CONNECTIONDOWN_EVENT);
      }
    });
  }

  inviteRouting(){
    const inviteKey =  window.localStorage.inviteKey;
    var requestedUrl = this.redirectionService.getRequestedUrlFromLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL);
    if (requestedUrl == 'invite' && inviteKey) {
      let url  = '/i/?c=' + inviteKey;
      if(this.universalService.browserDetails.os.name =="Android" || this.universalService.browserDetails.os.name =="iOS"){
        url = url + "&mob=true"
      } 
      window.location.href = url;
      this.redirectionService.removeRequestedUrlFromLocalStorage();
    } else{
      this.router.navigate(['home'])
    }	
  }
 

  promoRouting(){
    var requestedUrl = this.redirectionService.getRequestedUrlFromLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL);
    if (requestedUrl == 'promo' ) {
      let url  = '/promo';
      window.location.href = url;
      this.redirectionService.removeRequestedUrlFromLocalStorage();
    } else{
      this.router.navigate(['home'])
    }	
  }

  takeoutRouting(){
    var requestedUrl = this.redirectionService.getRequestedUrlFromLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL);
    if (requestedUrl == '/dataexport/history' ) {
      //this.cleverTapEventsService.exportHistoryClicked('Email');
      let url  = '/dataexport/history';
      window.location.href = url;
      this.redirectionService.removeRequestedUrlFromLocalStorage();
    } else if(window.location.href.indexOf('/dataexport/history') > -1 ){
      let url  = '/dataexport/history';
    } else if(window.location.href.indexOf('/dataexport') > -1 ){
      let url  = '/dataexport';
      window.location.href = url;
    } else{
      this.router.navigate(['home'])
    }	
  }

  checkUserStatus(){
    interval(5500).subscribe(x => {
      // if(!this.universalService.isSupprtedBrowser){
      //   return
      // }

      //any new static pages needs to be added here to avoid '/' routing.
      if (localStorage.jio === undefined) {
        if (window.location.href.indexOf('promotions')<0 && window.location.href.indexOf('jiomart')<0 && this.router.url != ('/') && !window.location.href.includes('?login') && window.location.href.indexOf('features') < 0 && window.location.href.indexOf('signin') < 0 && window.location.href.indexOf('downloadApp') < 0 && window.location.href.indexOf('spinthewheel')  && window.location.href.indexOf('scratchtowin') < 0 && window.location.href.indexOf('pricing') < 0 &&  window.location.href.indexOf('enterprise') < 0 && window.location.href.indexOf('events') < 0 && !this.universalService.inAppWebViewOpened) {
          this.router.navigate(['/']);
        }
      }
    });
  }

  @HostListener('window:mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  mousemove(event: any): void {
    clearTimeout(this.timer);
    this.timer=setTimeout(async ()=>{
      await this.check2FAstatus("Y");
     // this.localStorageSvc.setLastUserMovementTime(new Date().getTime(),false);
    },300);
    
  }


  async check2FAstatus(mouseMove){
    if(this.disablePassphraseInCurrentModule) return
    var checkLogin =localStorage.jio;
    //  if (checkLogin!=undefined && this.universalService.userLoggedIn == "true" && this.localStorageSvc.isStaySigned() == "true" && UniversalService.pingcall == undefined) {
    //     this.userloginController.ping();
    //  }
    let currentTme = new Date().getTime();//current time
   
    let lastUserMovementTime = this.localStorageSvc.getLastUserMovementTime(false)-5000;//
    let time = lastUserMovementTime ? lastUserMovementTime : currentTme;
    let timeDifference= currentTme - time; //differance between cuurent time last api call time
    let passedTime = this.universalService.msToTime(timeDifference);//fetch min. value from millieseconds
    let userData = this.localStorageSvc.getUserData(true) 
    if(checkLogin && !this.universalService.show2FApopUp && this.router.url != ('/') && window.location.href.indexOf('events') == -1 &&  window.location.href.indexOf('signin') == -1 && window.location.href.indexOf('pricing') == -1 && window.location.href.indexOf('downloadApp') == -1 && window.location.href.indexOf('searchdetails') == -1 && passedTime.minute >= ENV_CONSTANTS["constants"]["Interval_2FA"] && this.universalService.isStreaming == false){
   
      this.lastRefreshTime = localStorage.getItem('lastRefreshTime');
      let currentTime = new Date().getTime();
      let hours = (currentTime - this.lastRefreshTime) / 3600000;
      const expiresIn = userData["authToken"]["expiresIn"]/(1.2 * 60 * 60);
      //if(!(this.localStorageSvc.isStaySigned() == "true" && this.lastRefreshTime!=null && hours > expiresIn)) { 
      if(!(USER_DETAILS["USER_DETAILS"]["isStaySignIn"] == true && this.lastRefreshTime!=null && hours > expiresIn)) { 
        await this.pingBefore2Fa();
        await this.loginImplRef.getUserDetails();
        this.updateLastUserMovementTime(mouseMove)
      }else{
      
        setTimeout(() => {
          this.updateLastUserMovementTime(mouseMove)
        }, 200);
      }
      
      let is2FAEnabled = this.localStorageSvc.getTwoFAEnable(true);
      if(is2FAEnabled == 'Y' ){
        localStorage.removeItem('passPhraseValidationSuccess');
        //pause memory if showing passphrase popup
        this.universalService.pauseMemoryTimer();
        //Pause video if showing passphrase popup
        AppEvents.emit(EventsList.VIDEO_PLAYER_PAUSE);
        this.universalService.show2FApopUp = true;
        AppEvents.optionSelected.next({enable2FA: true});
      }else{
        AppEvents.optionSelected.next({enable2FA: false});
      }
    }else{
      this.updateLastUserMovementTime(mouseMove)
    }

  }

  pingBefore2Fa(){
    // this.lastRefreshTime = localStorage.getItem('lastRefreshTime');
 	  // let currentTime = new Date().getTime();
		// let hours = (currentTime - this.lastRefreshTime) / 3600000;
		// const expiresIn = this.localStorageSvc.getTokenExpiryDuration(true)/(1.2 * 60 * 60);
    if(this.router.url == ('/') && localStorage.getItem('passPhraseValidationSuccess') == "false"){
      return
    }//else 	if (this.localStorageSvc.isStaySigned() == "true" && this.lastRefreshTime!=null && hours > expiresIn) { 
     // return
    //}
      let classRef = this;
      let url =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["ping"];//
      return new Promise(function(resolve, reject){
        classRef.http.get(url).subscribe(
          async (suc) => { 
           await classRef.localStorageSvc.setRefreshTokenTime(new Date().getTime())
            resolve(suc);
          },
          (error) => {
            console.log("ping fail",error);
            reject(error);
          }
        );
      })
    }

    updateLastUserMovementTime(isMouseMove){
      if(isMouseMove == "Y" && this.router.url != ('/')){
        let cTime = new Date().getTime()+5000
        this.localStorageSvc.setLastUserMovementTime(cTime,false);

      }
    }
    
    checkIfAppIsSupportedOnCurrentBrowser(){
      var firefox = this.checkBrowserIsFireFox();
      var iosDevice = this.checkiOSdevice();
      if(firefox && iosDevice){
        // this.router.navigate(['/nosupport']);
        this.appSupported = false;
      }else{
        this.appSupported = true;
      }
    }

    checkiOSdevice() {
      return [
         'iPad Simulator',
         'iPhone Simulator',
         'iPod Simulator',
         'iPad',
         'iPhone',
         'iPod'
       ].includes(navigator.platform)
       || (navigator.userAgent.includes("Mac"))
   }

   checkBrowserIsFireFox(){
    if(navigator.userAgent.indexOf("Firefox") != -1){
      return true;
    }else{
      return false;
    }
   }

   checkBrowserIsEdge(){
    if(navigator.userAgent.indexOf("Edge") != -1){
      return true;
    }else{
      return false;
    }
   }

   clearStore(){
    this.db.clearStore('AllFilesMetadata_Grid_Name_Asc');
    this.db.clearStore('AllFilesMetadata_Grid_Date_Desc');
    this.db.clearStore('AllFiles_FolderMetadata_Name_Asc');
    this.db.clearStore('AllFiles_FolderMetadata_Date_Desc');
    this.db.clearStore('AllFilesMetadata_List_Name_Asc');
    this.db.clearStore('AllFilesMetadata_List_Name_Desc');
    this.db.clearStore('AllFilesMetadata_List_Date_Asc');
    this.db.clearStore('AllFilesMetadata_List_Date_Desc');
    this.db.clearStore('AllFilesMetadata_List_Size_Asc');
    this.db.clearStore('AllFilesMetadata_List_Size_Desc');
    this.db.clearStore('AllFilesMetadata_List_Type_Asc');
    this.db.clearStore('AllFilesMetadata_List_Type_Desc');
    this.db.clearStore('NextLink');
    this.db.clearStore('PhotosMetadata_ObjectName');
    this.db.clearStore('PhotosMetadata_FileCreatedDate');
    this.db.clearStore('PhotosMetadata_CreatedDate');
    this.db.clearStore('VideosMetadata_ObjectName');
    this.db.clearStore('VideosMetadata_FileCreatedDate');
    this.db.clearStore('VideosMetadata_CreatedDate');
    this.db.clearStore('ContactsStore_Asc');
    this.db.clearStore('ContactsStore_Dsc');
    this.db.clearStore('MyAlbumsList');
    this.db.clearStore('SharedAlbumsList');
    this.db.clearStore('DocumentMetadata_Name_Asc');
    this.db.clearStore('DocumentMetadata_Name_Desc');
    this.db.clearStore('DocumentMetadata_Size_Asc');
    this.db.clearStore('DocumentMetadata_Size_Desc');
    this.db.clearStore('DocumentMetadata_Type_Asc');
    this.db.clearStore('DocumentMetadata_Type_Desc');
    this.db.clearStore('DocumentMetadata_FileCreatedDate_Asc');
    this.db.clearStore('DocumentMetadata_FileCreatedDate_Desc');
    this.db.clearStore('DocumentMetadata_CreatedDate_Asc');
    this.db.clearStore('DocumentMetadata_CreatedDate_Desc');
    this.db.clearStore('AudiosMetadata_Name_Asc');
    this.db.clearStore('AudiosMetadata_Name_Desc');
    this.db.clearStore('AudiosMetadata_FileCreatedDate_Asc');
    this.db.clearStore('AudiosMetadata_FileCreatedDate_Desc');
    this.db.clearStore('AudiosMetadata_CreatedDate_Asc');
    this.db.clearStore('AudiosMetadata_CreatedDate_Desc');
    this.db.clearStore('RecentFilesMetadata');
    this.db.clearStore('AllFilesMetadata_Grid_Name_Desc');
    this.db.clearStore('AllFilesMetadata_Grid_Date_Asc');
    this.db.clearStore('AllFilesMetadata_Grid_CreatedDate_Asc');
    this.db.clearStore('AllFilesMetadata_Grid_CreatedDate_Desc');
    this.db.clearStore('VideosMetadata_ObjectName_Desc');
    this.db.clearStore('VideosMetadata_FileCreatedDate_Asc');
    this.db.clearStore('VideosMetadata_CreatedDate_Asc');
    this.db.clearStore('PhotosMetadata_ObjectName_Desc');
    this.db.clearStore('PhotosMetadata_FileCreatedDate_Asc');
    this.db.clearStore('PhotosMetadata_CreatedDate_Asc');
    this.db.clearStore('AllFiles_FolderMetadata_Name_Desc');
    this.db.clearStore('AllFiles_FolderMetadata_Date_Asc');
   }

   async showFeaturesForEntUsers(){ 
    let userData = this.localStorageSvc.getUserData(true) 
    if(localStorage.jio && userData){
      if(userData.jcEntInfo){ 
        this.universalService.showFeaturesForEntUsers = true;
        userData.jcEntInfo.isAllowPublicShare == "Y"? this.universalService.isAllowPublicShare = true : this.universalService.isAllowPublicShare = false;
        if(userData.jcEntInfo.isAllowExtPrivateShare == "Y"){
          this.universalService.isAllowExtPrivateShare = true;
          this.universalService.isAllowEnternalPrivateShare = false;
        }else if(userData.jcEntInfo.isAllowExtPrivateShare == "N"){
          this.universalService.isAllowEnternalPrivateShare = true;
          this.universalService.isAllowExtPrivateShare = false;
        }
      }else{
        this.universalService.showFeaturesForEntUsers = false;
        this.universalService.isAllowPublicShare = true;
        this.universalService.isAllowEnternalPrivateShare = false;
        this.universalService.isAllowExtPrivateShare = false;
      }
    }
   }

  populateUserDataToLocalConstant(){
    var userDataClass = new UserData();
    let userData = this.localStorageSvc.getUserData(true)
    if(userData){
      userDataClass.setUserDataInGlobalConstant(userData)
    }else{
      USER_DETAILS["USER_DETAILS"] = DEFAULT_USER_DETAILS;
    }
    AppEvents.updateAuthData.subscribe(ev=>{
      if(ev["updateAuthData"] && ev["userData"]){
        this.localStorageSvc.setUserData(ev["userData"],true);
        userDataClass.setUserDataInGlobalConstant(ev["userData"])
      }else if(ev["updateProperty"] && ev["property"]){
        var userData = this.localStorageSvc.getUserData(true);
        userData[ev["property"]["key"]] = ev["property"]["value"];
        this.localStorageSvc.setUserData(userData,true);
        userDataClass.setUserDataInGlobalConstant(userData)
      }else if(ev["removeProperty"] && ev["property"]){
        var userData = this.localStorageSvc.getUserData(true);
        delete userData[ev["property"]];
        this.localStorageSvc.setUserData(userData,true);
        userDataClass.setUserDataInGlobalConstant(userData)
      }

      if(ev["updateStorageRepresentationOnUI"]){
        AppEvents.updateLeftMenuStorage.next({ updateLeftMenuStorage: true });
        AppEvents.updateUserStorage.next({updateUserStorage:true});
      }
    })
  }

  lazyInjectResources(){
    this.lazyInjectorService.lazyInjectCss('global', this.renderer2);
    this.lazyInjectorService.LazyInjectJSScripts('multiselect');
    this.lazyInjectorService.LazyInjectJSScripts('swiper');
    this.lazyInjectorService.LazyInjectJSScripts("clappr");
    setTimeout(() => {
      this.lazyInjectorService.LazyInjectJSScripts("levelselector");
    }, 1);
    if(this.universalService.isMobileDevice){
      this.lazyInjectorService.LazyInjectJSScripts('longpress');
    }
  }
}


